import { FC } from 'react';
import { BlackAddIcon } from '../../../../assets/images/countryList';
import './addCountry.scss';
interface IAddCountry {
  className?: string;
  action?: () => void;
  disabled?: boolean;
}

const AddCountry: FC<IAddCountry> = ({ className, action, disabled }: IAddCountry) => {
  return (
    <div id="addCountry">
      <div
        className={`containerAddCountry ${className || ''} ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        onClick={() => {
          if (action && !disabled) {
            action();
          }
        }}
      >
        <div className="addIcon">
          <BlackAddIcon fill={disabled ? '#CCCCCC' : ''} />
        </div>
        <div className="textAdd" style={{ color: disabled ? '#CCCCCC' : '' }}>
          Agregar país
        </div>
      </div>
    </div>
  );
};
export default AddCountry;
